import { Component, Input } from '@angular/core';

import { CALL_LOG_EVENT_DIRECTION, UICallLogEvent } from '../../models/call-history.model';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
})
export class OverviewComponent {
  @Input() callItem: UICallLogEvent;
  public dateFormat = {
    short: 'MM/dd/yy HH:mm',
    long: 'MMM dd yyyy HH:mm:ss',
  };

  public PhoneCallDirections = CALL_LOG_EVENT_DIRECTION;

  public isNumber(v: number | string): boolean {
    return typeof v === 'number';
  }
}
